import { ButtonProps } from '@chakra-ui/react';
import Button from '~/components/Button';
import IconButton from '~/components/IconButton';
import { ShareIcon } from '~/components/icons';
import { useBreakpointValue } from '~/utils-ts';

export const ShareButton: React.FC<ButtonProps> = ({ ...props }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return (
      <IconButton
        {...props}
        colorScheme="primary"
        rounded="full"
        aria-label="Share media pack"
        icon={<ShareIcon color="white" boxSize={4} />}
      />
    );
  }

  return (
    <Button
      {...props}
      colorScheme="primary"
      fontWeight="medium"
      rounded="full"
      fontSize="sm"
      leftIcon={<ShareIcon color="white" boxSize={4} />}
    >
      Share
    </Button>
  );
};
